<!-- src/components/BottomTab.vue -->
<template>
    <!-- 添加自定义 class "black-gold-tabbar" -->
    <van-tabbar :model-value="activeSection" fixed class="black-gold-tabbar" :class="{ 'pcd-ui pcd-navigation': forest }" :safe-area-inset-bottom="true" :border="false">
      <!-- Explicit navigation lets an active child section return to its root. -->
      <van-tabbar-item name="home" @click="router.replace('/')">
        <template #icon="{ active }">
            <van-icon v-if="forest" name="home-o" aria-hidden="true" /><img v-else :src="active ? tabHomeActive : tabHome" />
        </template> {{ t("首頁") }} </van-tabbar-item>
      <van-tabbar-item name="wallet" @click="router.replace('/wallet')">
        <span>{{ t("錢包") }}</span>
        <template #icon="{ active }">
            <van-icon v-if="forest" name="balance-o" aria-hidden="true" /><img v-else :src="active ? tabWalletActive : tabWallet" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="mining" @click="router.replace('/mine')">
        <template #icon="{ active }">
            <van-icon v-if="forest" name="gem-o" aria-hidden="true" /><img v-else :src="active ? tabMiningActive : tabMining" />
        </template> {{ t("挖礦") }} </van-tabbar-item>
      <van-tabbar-item name="ecosystem" @click="router.replace('/ecosystem')"><template #icon><van-icon name="cluster-o" aria-hidden="true" /></template>{{ t('生態') }}</van-tabbar-item>
    </van-tabbar>
  </template>
  
  <script setup>
import { t } from '@/i18n';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
const route = useRoute(), router = useRouter();
const activeSection = computed(() => !route ? '' : route.name === 'nft-detail' && route.query.from === 'ecosystem' ? 'ecosystem' : route.meta?.section || ({ '/': 'home', '/wallet': 'wallet', '/mine': 'mining' }[route.path] || ''));
import tabHomeActive from '@/assets/images/tab_home_active.png';
import tabHome from '@/assets/images/tab_home.png';
import tabWalletActive from '@/assets/images/tab_wallet_active.png';
import tabWallet from '@/assets/images/tab_wallet.png';
import tabMiningActive from '@/assets/images/tab_mining_active.png';
import tabMining from '@/assets/images/tab_mining.png';

  defineProps({ forest: Boolean });

  </script>
  
  <style scoped>
.black-gold-tabbar {
  background-color: #0f1a0f;        /* 稍微淺一點的黑色背景，與頁面黑色區分 */
  box-shadow: 0 -1px 5px rgba(16, 185, 129, 0.2); /* 添加金色陰影效果 */
  border-top: 1px solid rgba(16, 185, 129, 0.3);  /* 半透明金色頂部邊框 */
}

/* 默认状态下文字颜色和图标颜色为金色 */
.black-gold-tabbar .van-tabbar-item {
  color: #059669;  /* 调暗颜色 */
}

/* 激活状态下背景色透明，文字颜色改为翡翠綠 + 發光效果 */
.black-gold-tabbar .van-tabbar-item--active {
  background-color: transparent;
  color: #10b981;
  text-shadow: 0 0 8px rgba(16, 185, 129, 0.6);
}
</style>
